"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutosaveDisabled = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var AutosaveDisabled = function AutosaveDisabled() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.345 3.023c3.344-.284 6.35 2.06 6.929 5.404 3.282.124 5.844 2.916 5.722 6.236-.123 3.32-2.883 5.911-6.165 5.787H5.403C2.42 20.45 0 18.003 0 14.985S2.42 9.52 5.403 9.52C5.423 6.126 8 3.307 11.345 3.023zm3.786 11.908a.527.527 0 00-.164-.383l-1.74-1.749 1.74-1.77a.527.527 0 000-.765l-.573-.58a.516.516 0 00-.756 0l-1.75 1.76-1.752-1.76a.516.516 0 00-.756 0l-.573.58a.528.528 0 000 .765l1.74 1.77-1.74 1.77a.528.528 0 000 .766l.573.58a.516.516 0 00.756 0l1.751-1.76 1.75 1.738a.516.516 0 00.757 0l.573-.58a.527.527 0 00.164-.382z",
    clipRule: "evenodd"
  }));
};

exports.AutosaveDisabled = AutosaveDisabled;